import { render, staticRenderFns } from "./vpthome.vue?vue&type=template&id=76f977bc&scoped=true"
import script from "./vpthome.vue?vue&type=script&lang=js"
export * from "./vpthome.vue?vue&type=script&lang=js"
import style0 from "./vpthome.vue?vue&type=style&index=0&id=76f977bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f977bc",
  null
  
)

export default component.exports